export default __webpack_public_path__ + "static/precoDeVenda2-49be8ae8a471ea74653e696704a66124.jpeg";